/**
 * Quem pode disparar um template para ESTA conversa.
 *
 * A regra vive aqui, e nao dentro de um componente, porque dois lugares
 * perguntam a mesma coisa: o botao do rodape do ReplyBox e o botao do aviso de
 * janela de 24 h, que fica no MessagesView. Duplicar a condicao faria os dois
 * divergirem no primeiro ajuste — e um botao que aparece sem poder disparar e
 * pior que botao nenhum.
 *
 * Espelha o Outbound: so administrador, e so quando ha telefone para onde
 * mandar.
 *
 * ACESSO-01 (L8b): `decide` e o do `useAcesso`. Com a chave ACESSO_GRANULAR
 * ligada, quem dispara e quem tem o `outbounds:send`, como no Outbound
 * (`outbounds#send_template`); desligada, o administrador, como hoje. Sem ele,
 * o papel.
 */
export function canDispatchTemplate({
  isOutboundsEnabled,
  role,
  phoneNumber,
  isOnPrivateNote = false,
  decide = (_escopo, hoje) => hoje(),
} = {}) {
  return Boolean(
    isOutboundsEnabled &&
    decide('outbounds:send', () => role === 'administrator') &&
    phoneNumber &&
    !isOnPrivateNote
  );
}

export default { canDispatchTemplate };
